var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33385",
    "data-name": "Path 33385",
    d: "M22.727,21.668l-4.9-4.9a9,9,0,1,0-1.058,1.059l4.9,4.9a.749.749,0,1,0,1.059-1.059ZM3.484,10.969a7.486,7.486,0,1,1,7.486,7.486,7.486,7.486,0,0,1-7.486-7.486Z",
    transform: "translate(-1.946 -1.946)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyColored);
export default __webpack_public_path__ + "static/media/magnify-colored.a921783f1246977ca3a58b4bd7bdc07a.svg";
export { ForwardRef as ReactComponent };